(() => {
  function initSizeChoice() {
    document.querySelectorAll('[data-mp-size-prompt]').forEach(prompt => {
      if (prompt.dataset.ready) return;
      const info = prompt.closest('product-info');
      if (!info) return;
      const picker = info.querySelector('variant-picker');
      const group = picker?.querySelectorAll('fieldset, select')[Number(prompt.dataset.position) - 1];
      if (!group || group.tagName !== 'FIELDSET') return;
      const radios = group.querySelectorAll('input[type="radio"]');
      if (!radios.length) return;
      prompt.dataset.ready = 'true';
      let selected = prompt.dataset.explicit === 'true';
      const status = prompt.querySelector('[data-mp-size-status]');
      const initial = status.textContent;
      if (!selected) {
        radios.forEach(radio => { radio.checked = false; });
        const valueLabel = group.querySelector('.form__label span[id]');
        if (valueLabel) valueLabel.textContent = '—';
      }
      const paint = value => {
        status.textContent = value ? `${prompt.dataset.selected} ${value}` : initial;
        prompt.removeAttribute('data-invalid');
      };
      if (selected) paint(group.querySelector('input:checked')?.value);
      info.addEventListener('change', event => {
        const input = event.target;
        if (!input.matches('variant-picker input[type="radio"]')) return;
        const groups = [...input.closest('variant-picker').querySelectorAll('fieldset, select')];
        if (groups.indexOf(input.closest('fieldset')) !== Number(prompt.dataset.position) - 1) return;
        selected = true;
        paint(input.value);
      }, true);
      const guard = event => {
        if (selected) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        status.textContent = prompt.dataset.error;
        prompt.setAttribute('data-invalid', '');
        prompt.scrollIntoView({ block: 'center', behavior: 'auto' });
        info.querySelector('variant-picker fieldset input[type="radio"]')?.focus({ preventScroll: true });
      };
      info.addEventListener('submit', event => {
        if (event.target.matches('form[action*="/cart/add"]')) guard(event);
      }, true);
      info.addEventListener('click', event => {
        if (event.target.closest('[data-mw-wa-link],button[name="add"]')) guard(event);
      }, true);
    });
  }
  initSizeChoice();
  document.addEventListener('shopify:section:load', initSizeChoice);
  document.addEventListener('product-info:loaded', initSizeChoice);
})();
